import { Grid } from '@mui/material';
import { WsColors, WsTitleBanner } from 'wisestep-base';

const BusinessMetricsLayout = ({ children }: { children: JSX.Element }) => {
  return (
    <Grid container>
      <Grid xs={12} pb={2}>
        <WsTitleBanner title={'Business Metrics'} />
      </Grid>

      <Grid item container bgcolor={WsColors.White} p={4} spacing={2} gap={4}>
        {children}
      </Grid>
    </Grid>
  );
};

export default BusinessMetricsLayout;
